import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api.js";

export interface EmployeeOption {
  id: string;
  fullName: string;
  email: string;
}

interface EmployeesResponse {
  items: EmployeeOption[];
}

/**
 * Aktive Mitarbeiter für Auswahlfelder. Mit `segmentId` nur die aktuellen
 * Mitglieder dieses Bereichs — der Server entscheidet das über die
 * Team-Mitgliedschaft, nicht über das abgeleitete Profilfeld.
 */
export function useEmployees(segmentId?: string) {
  return useQuery<EmployeeOption[]>({
    queryKey: ["employees", segmentId ?? null],
    queryFn: async () => {
      const res = await api.get<EmployeesResponse>(
        segmentId ? `/employees?segmentId=${segmentId}` : "/employees",
      );
      return res.items;
    },
    staleTime: 60_000,
  });
}
